var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCaregivers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 16,
    viewBox: "0 0 24 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.9029 9.41227C12.1996 9.60413 13.3756 9.93173 14.4035 10.3158C15.9226 10.8945 16.8791 12.1966 16.8791 13.6072V15.5603H0V13.6193C0 12.1966 0.956484 10.8945 2.47561 10.3278C3.56762 9.91182 4.82686 9.56482 6.22044 9.37842L8.57143 11.1318L10.9029 9.41227Z",
    fill: "#00A3FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.21863 8.17583C7.03026 8.33315 7.38461 8.43956 8.4396 8.43956C9.49459 8.43956 10.6606 8.17583 10.6606 8.17583C11.8681 7.91209 12.8015 7.09253 12.6414 5.86615L12.3213 3.36231C12.0111 1.42055 10.3604 0 8.4396 0C6.51876 0 4.86805 1.42055 4.55791 3.36231L4.23778 5.86615C4.07771 7.09253 5.01103 7.91209 6.21863 8.17583Z",
    fill: "#00A3FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8589 10.8132C18.3576 10.8132 17.8821 10.8607 17.4065 10.9319C17.9206 11.7389 18.2162 12.6647 18.2162 13.6497V15.5605H23.9999V13.6972C23.9999 12.7359 23.383 11.8814 22.4319 11.5016C21.3394 11.0625 20.1313 10.8132 18.8589 10.8132Z",
    fill: "#00A3FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0526 14.0144C11.2122 14.166 11.41 14.2418 11.646 14.2418H13.9363C14.1723 14.2418 14.3701 14.166 14.5297 14.0144C14.6894 13.8627 14.7692 13.6748 14.7692 13.4506C14.7692 13.2265 14.6894 13.0385 14.5297 12.8869C14.3701 12.7352 14.1723 12.6594 13.9363 12.6594H11.646C11.41 12.6594 11.2122 12.7352 11.0526 12.8869C10.893 13.0385 10.8131 13.2265 10.8131 13.4506C10.8131 13.6748 10.893 13.8627 11.0526 14.0144Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1538 9.67021C19.5802 9.67021 20.7472 8.50318 20.7472 7.07681C20.7472 5.65043 19.5802 4.4834 18.1538 4.4834C16.7275 4.4834 15.5604 5.65043 15.5604 7.07681C15.5604 8.50318 16.7275 9.67021 18.1538 9.67021Z",
    fill: "#00A3FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaregivers);
export default __webpack_public_path__ + "static/media/caregivers.8560ff2bc4ad03824ea6a9a676924b66.svg";
export { ForwardRef as ReactComponent };